import React from "react";
import { useSelector } from "react-redux";
import style from "./measurementStatus.module.scss";
import { Button } from "../../../primary";
import { MeasurementLoader } from "./measurementLoader";

export const MeasurementStatus = ({ showMeasurementModal, pendingRetires, maxPendingRetries }) => {
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };
  const status = measurementData?.status;
  const isStickerAvailable = measurementData?.isStickerAvailable === 1;

  const errorStatus = status === "error" || status === "no_measurements";

  return (
    <div className="col w-100 pl-4 pr-4 text-center">
      <div className={style.btns_top_space}>
        <div className="mb-3">
          {status === "pending" && (
            <>
              <MeasurementLoader />
              {pendingRetires >= maxPendingRetries && (
                <span style={{ fontSize: 18 }}>It's taking longer than usual, please check back after 5 mins.</span>
              )}
            </>
          )}
          {isStickerAvailable && errorStatus && (
            <>
              <p className={`${style.dim_man_p}`}>
                Tap{" "}
                <Button
                  type="button"
                  value="Retrace"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  id="autoMeasurement"
                  onClick={() => {
                    showMeasurementModal("Retrace Wound Edges");
                  }}
                />{" "}
                to redraw wound edges, or enter{" "}
                <Button
                  type="button"
                  value="Dimensions"
                  id="autoMeasurement"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  onClick={() => showMeasurementModal("Dimensions")}
                />{" "}
                manually.
              </p>
            </>
          )}

          {!isStickerAvailable && (errorStatus || status === "do_manual_trace") && (
            <>
              <p className={`${style.dim_man_p}`}>
                Enter{" "}
                <Button
                  type="button"
                  value="Dimensions"
                  id="autoMeasurement"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  onClick={() => showMeasurementModal("Dimensions")}
                />{" "}
                manually.
              </p>
            </>
          )}
          {isStickerAvailable && status === "do_manual_trace" && (
            <>
              <p className={`${style.dim_man_p}`}>
                Tap{" "}
                <Button
                  type="button"
                  value="Retrace"
                  classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                  id="autoMeasurement"
                  onClick={() => {
                    showMeasurementModal("Retrace Wound Edges");
                  }}
                />{" "}
                to redraw wound edges.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
